import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import { Link } from "react-router-dom";
import "./style.scss";
import AuthLayout from "../../../components/authlayout";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
const Register = () => {
  const history = useNavigate()
  const token = sessionStorage.getItem("token")
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", password: "", mobileNo: "", dialCode: "", isTwillio: false })
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false, currentPassword: false })

  useEffect(() => {
    if (token) {
      history("/dashboard")
    }
  }, []);

  const hendleSubmit = (e: any) => {
    e.preventDefault()
    let data: any = {
      ...form,
    }
    let url = "user/register"
    loader(true)
    ApiClient.post(url, data).then(async (res) => {
      if (res.success) {
        loader(false)
        toast?.success(res?.message)
        history("/login")
      } else {
        toast?.error(res?.message)
        loader(false)
      }
    })
  }

  const handleChangePhone = (phone: any, country: any) => {
    const dialCode = country?.dialCode
    setForm((prev: any) => ({ ...prev, dialCode: dialCode, mobileNo: phone?.replace(dialCode, "") }))
  }

  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <AuthLayout>
        <div className="w-[100%]">
          <img src="/assets/img/ed/logopng.png" onClick={() => history(`/`)} className="w-[200px] mx-auto pb-6 cursor-pointer" alt="logo" />
          <form className="w-full mx-auto" onSubmit={hendleSubmit} autoComplete="one-time-code">
            <div className="text-center">
              <h1 className="text-[24px] font-semibold text-black">Sign Up</h1>
              <span className="flex w-10 mx-auto h-1 bg-[#F58D18] mt-1"></span>
            </div>
            <div className="mt-5">
              <div className="flex items-center gap-4">
                <input type="text" className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[14px]" placeholder="First Name" value={form?.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} required autoComplete="one-time-code" />
                <input type="text" className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[14px]" placeholder="Last Name" value={form?.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} required autoComplete="one-time-code" />
              </div>
              <input type="email" className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[14px]" placeholder="Email" value={form?.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoComplete="one-time-code" />
              <div className="mb-4">
              <PhoneInput
                placeholder="Mobile Number"
                inputClass="signupMobileNumber"
                buttonClass="signupMobileNumber"
                country={"us"}
                value={form?.mobileNo ? form?.dialCode + form?.mobileNo : null}
                enableSearch={true}
                inputProps={{
                  required: true,
                  autoComplete: "one-time-code",
                  onFocus: () => setIsFocused(true),
                  onBlur: () => setIsFocused(false),
                }}
                onChange={(phone, country) =>
                  handleChangePhone(phone, country)
                }
              />
              {isFocused && (
                <label className="text-[12px] text-[#2563eb] bg-[#e6eeff] rounded-lg border-l-[3px] border-[#2563eb] p-3 mt-4 block">
                  By providing your mobile number, you agree to receive informational text messages from Frum Me 2 U.
                </label>
              )}
            </div>
              <div className="relative">
                <input type={eyes.password ? "text" : "password"} className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[10px]" value={form?.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" required autoComplete="one-time-code" />
                {eyes.password ? (
                  <FiEye className="top-1/2 -translate-y-1/2 right-3 absolute text-[#222] cursor-pointer" onClick={() => setEyes({ ...eyes, password: !eyes.password })} />
                ) : (
                  <FiEyeOff className="top-1/2 -translate-y-1/2 right-3 absolute text-[#222] cursor-pointer" onClick={() => setEyes({ ...eyes, password: !eyes.password })} />
                )}
              </div>
            </div>
            <div className="flex gap-2 items-start mt-3">
              <input type="checkbox" id="checkboxInput" checked={form?.isTwillio} onChange={e => setForm((prev) => ({ ...prev, isTwillio: e.target.checked }))} className="cursor-pointer mt-[3px]" />
              <label htmlFor="checkboxInput" className="!mb-0 cursor-pointer break-words !block mt-[-2px]">
                By filling in the form above and clicking the "Sign Up" button, I agree to receive text messages from Frum Me 2 U.
              </label>
              {/* <label htmlFor="checkboxInput" className="!mb-0 cursor-pointer break-words !block mt-[-2px]">
                By filling in the forms above and clicking the "Sign Up" button you accept and agree to FRUM ME 2 U
                <Link to={"/privacy"} className="underline text-[#EB6A59] mx-2">Privacy Policy</Link> and
                <Link to={"/terms"} className="underline text-[#EB6A59] ml-2">Terms of Service</Link>.
              </label> */}
            </div>
            <div className="mt-4 flex items-center justify-center">
              <button type="submit" className="h-11 rounded-[10px] w-full font-semibold text-center text-[#fff] hover:opacity-80 transition-all">Sign Up</button>
            </div>
            <p className="text-[14px] mt-4 text-center font-normal text-black">Already have an account? <Link className="text-[#EB6A59] font-semibold text-[14px]" to="/login">Sign In</Link></p>
          </form>
        </div>
      </AuthLayout>
    </>
  );
};

export default Register;
